
import React from 'react';
import AdminLayout from '@/components/layout/AdminLayout';
import SEOForm from '@/components/admin/seo/SEOForm';
import StatusAlerts from '@/components/admin/seo/StatusAlerts';
import { useSEOSettings } from '@/hooks/useSEOSettings';

const SEOManagement = () => {
  const {
    settings,
    loading,
    error,
    success,
    handleInputChange,
    updateSEOSettings,
  } = useSEOSettings();

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold">SEO Settings</h1>
        </div>

        <StatusAlerts error={error} success={success} />

        <SEOForm 
          settings={settings} 
          loading={loading} 
          handleInputChange={handleInputChange} 
          handleSubmit={updateSEOSettings} 
        />
      </div>
    </AdminLayout>
  );
};

export default SEOManagement;
